export default __webpack_public_path__ + "static/media/3.25bfca5f.jpg";